"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDetailPage = void 0;
const react_1 = __importStar(require("react"));
const config_1 = __importDefault(require("next/config"));
const router_1 = require("next/dist/client/router");
const monera_app_core_1 = require("@amzn/monera-app-core");
const components_1 = require("@amzn/monera-app-core-components/lib/components");
const static_component_1 = require("@amzn/monera-app-core-components/lib/components/static-component");
const gql_1 = require("@amzn/monera-app-core/lib/gql");
const models_1 = require("@amzn/monera-app-core/lib/models");
const error_1 = require("@amzn/monera-app-core/lib/models/error");
const config_2 = require("@amzn/monera-app-core/lib/utils/config");
const error_2 = require("@amzn/monera-app-core/lib/utils/error");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const request_validator_1 = require("@amzn/monera-app-core/lib/utils/request-validator");
const shopping_portal_1 = require("@amzn/monera-app-core/lib/utils/shopping-portal");
const _error_1 = require("../_error");
const headers_1 = require("../../utils/headers");
const createDetailPage = (props) => {
    const { tenantTheme = {}, componentsMap, spOverrides } = props;
    const DetailPage = (props) => {
        var _a, _b;
        const { error } = props;
        const router = (0, router_1.useRouter)();
        const { moneraTools } = router.query;
        const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
        const [shoppingPortalState] = (0, monera_app_core_1.useShoppingPortalStore)();
        const layout = configStoreState.layout;
        const requestId = configStoreState.requestId;
        const tenant = configStoreState.tenant;
        const adgwdg = (_a = configStoreState.routing) === null || _a === void 0 ? void 0 : _a.adgwdg;
        const countryCode = configStoreState.countryCode;
        monera_app_core_1.serverConsole.log(`Rendering DetailPage for asin: ${configStoreState.asin}, adgwdg: ${adgwdg}, countryCode: ${countryCode}`);
        (0, react_1.useEffect)(() => {
            if ((0, monera_app_core_1.isClientSide)()) {
                (0, config_2.initClientsideConfig)(configStoreState, shoppingPortalState.deviceType);
                monera_app_core_1.csm.emitPlatformTag();
                monera_app_core_1.csm.emitTenantStandardTag();
            }
        }, []);
        (0, react_1.useEffect)(() => {
            const statusCode = window.moneraStatusCode;
            const tenant = window.moneraTenant;
            if (statusCode) {
                (0, metric_helper_1.meterStatusCode)({ statusCode, tenant, methodName: 'DetailPage', requestId });
            }
        });
        (0, react_1.useEffect)(() => {
            const methodName = 'DetailPage';
            const metricName = 'PageCount:GetDetailPage';
            const value = 1;
            (0, metric_helper_1.emitCountMetrics)(methodName, metricName, value, requestId, tenant);
        }, []);
        if (error) {
            return react_1.default.createElement(_error_1.ErrorPage, { error: error, statusCode: (_b = error.statusCode) !== null && _b !== void 0 ? _b : 500 });
        }
        return (react_1.default.createElement(components_1.PageWrapper, { pageType: models_1.PageType.DetailPage, deviceType: shoppingPortalState.deviceType || monera_app_core_1.DeviceType.Desktop, tenant: tenant, tenantTheme: tenantTheme, componentsMap: componentsMap },
            moneraTools === 'true' && react_1.default.createElement(components_1.Rerenderer, { "aria-label": "Rerender Button", copy: "+" }),
            react_1.default.createElement(components_1.CoreFonts, null),
            react_1.default.createElement(static_component_1.StaticComponent, Object.assign({}, layout))));
    };
    DetailPage.getInitialProps = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { req, query, res } = ctx;
        const requestId = req ? req.id : window.moneraRequestId;
        const getDetailPage = 'GetDetailPage';
        const configStoreActions = monera_app_core_1.registry.getStore(monera_app_core_1.configStore, requestId).getActions();
        const shoppingPortalState = monera_app_core_1.registry.getStore(monera_app_core_1.shoppingPortalStore, requestId).getState();
        const { asin, tenantIdOverride } = query;
        const customerId = shoppingPortalState.customerId;
        let deviceType = shoppingPortalState.deviceType;
        if (deviceType === null) {
            monera_app_core_1.serverConsole.error(`Invalid DeviceAttributes: "${shoppingPortalState.deviceAttributes}". Falling back to DESKTOP`);
            (0, metric_helper_1.meterFatals)({ methodName: 'DetailPage', metricName: 'GetDeviceType', error: true, requestId });
            deviceType = monera_app_core_1.DeviceType.Desktop;
        }
        else {
            (0, metric_helper_1.meterFatals)({ methodName: 'DetailPage', metricName: 'GetDeviceType', success: true, requestId });
        }
        const locale = shoppingPortalState.locale;
        const marketplaceId = shoppingPortalState.marketplaceId;
        const ipAddress = shoppingPortalState.forwardedFor;
        const internalIpClass = shoppingPortalState.internalIpClass;
        const slateToken = shoppingPortalState.slateToken;
        const config = (0, config_1.default)();
        let envShoppingPortal = monera_app_core_1.ENV_SHOPPING_PORTAL;
        if ((0, monera_app_core_1.isClientSide)() && config) {
            const { publicRuntimeConfig } = config;
            envShoppingPortal = publicRuntimeConfig.envShoppingPortal;
        }
        configStoreActions.update({ asin });
        configStoreActions.update({ pageType: models_1.PageType.DetailPage });
        (0, config_2.persistConfigState)({ query, configStoreActions, url: req === null || req === void 0 ? void 0 : req.url, incomingHeaders: req === null || req === void 0 ? void 0 : req.headers });
        const startTime = Date.now();
        const headers = Object.assign(Object.assign({ [models_1.ShoppingPortalHeadersEnum.UBID]: shoppingPortalState.ubid, [models_1.ShoppingPortalHeadersEnum.SessionId]: shoppingPortalState.sessionId, [models_1.ShoppingPortalHeadersEnum.AuthToken]: req === null || req === void 0 ? void 0 : req.headers[models_1.ShoppingPortalHeadersEnum.AuthToken], [models_1.ShoppingPortalHeadersEnum.TransitiveAuthToken]: req === null || req === void 0 ? void 0 : req.headers[models_1.ShoppingPortalHeadersEnum.TransitiveAuthToken], [models_1.ShoppingPortalHeadersEnum.Cookie]: req === null || req === void 0 ? void 0 : req.headers.cookie, [monera_app_core_1.HTTPHeaders.XForwardedFor]: ipAddress, [models_1.ShoppingPortalHeadersEnum.InternalIpClass]: internalIpClass, [models_1.ShoppingPortalHeadersEnum.RequestId]: requestId, [models_1.OverrideHeaderEnums.TenantIdOverride]: tenantIdOverride, [models_1.ShoppingPortalHeadersEnum.SlateToken]: slateToken, [models_1.ShoppingPortalHeadersEnum.DeviceAttributes]: shoppingPortalState.deviceAttributes, [models_1.ShoppingPortalHeadersEnum.I18nPreferences]: shoppingPortalState.i18nPreferences, [monera_app_core_1.HTTPHeaders.XForwardedProto]: req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.HTTPHeaders.XForwardedProto] }, (0, shopping_portal_1.getWeblabOverrideHeader)(req)), { [monera_app_core_1.HTTPHeaders.DeviceAttributes]: shoppingPortalState.deviceAttributes, [monera_app_core_1.HTTPHeaders.I18nPreferences]: shoppingPortalState.i18nPreferences });
        (0, headers_1.addHeader)(headers, monera_app_core_1.HTTPHeaders.UserAgent, req === null || req === void 0 ? void 0 : req.headers[monera_app_core_1.HTTPHeaders.UserAgent]);
        if ((_a = req === null || req === void 0 ? void 0 : req.headers) === null || _a === void 0 ? void 0 : _a.referer) {
            headers[monera_app_core_1.HTTPHeaders.Referer] = (_b = req === null || req === void 0 ? void 0 : req.headers) === null || _b === void 0 ? void 0 : _b.referer;
        }
        const detailPageResP = (0, gql_1.queryMoneraService)({
            gqlQuery: gql_1.getDetailPageGqlQuery,
            variables: {
                asin,
                customerId,
                deviceType,
                platformType: (0, shopping_portal_1.getPlatformType)(shoppingPortalState.deviceAttributes),
                marketplaceId,
                locale,
                pageType: models_1.PageType.DetailPage
            },
            headers
        });
        const detailPageRes = yield detailPageResP;
        const moneraServiceResponseTime = Date.now() - startTime;
        if ((0, error_1.isRedirect)(detailPageRes)) {
            (0, error_1.doRedirect)(detailPageRes, req, res);
            const methodName = 'DetailPage';
            const metricName = 'RedirectCount:GetDetailPage';
            const value = 1;
            (0, metric_helper_1.emitCountMetrics)(methodName, metricName, value, requestId, (0, config_2.retrieveConfigState)(headers).tenantId);
            return {};
        }
        if ((0, models_1.isError)(detailPageRes)) {
            const faultStatusCode = 500;
            let statusCode = (0, models_1.getStatusCodeFromErrorType)(detailPageRes.name);
            const queryParams = {
                marketplaceId,
                locale
            };
            const queryParametersWithEmptyValue = (0, request_validator_1.getParametersWithEmptyValue)(queryParams);
            const isQueryParamMissingValue = queryParametersWithEmptyValue.length !== 0;
            if (isQueryParamMissingValue) {
                statusCode = faultStatusCode;
                const methodName = 'DetailPage';
                const metricName = 'QueryParameterWithEmptyValueCount';
                const value = 1;
                (0, metric_helper_1.emitCountMetrics)(methodName, metricName, value, requestId, (0, config_2.retrieveConfigState)(headers).tenantId);
            }
            if (res) {
                res.statusCode = statusCode;
            }
            const statusCodePrefix = statusCode.toString().charAt(0);
            if (res) {
                res.statusCode = statusCode;
            }
            const error = Object.assign(Object.assign({}, detailPageRes), { statusCode });
            const segment = req === null || req === void 0 ? void 0 : req.segment;
            segment && (0, error_2.addErrorToXray)(segment, error);
            (0, metric_helper_1.meterFatals)({
                methodName: 'DetailPage',
                metricName: getDetailPage,
                error: statusCodePrefix === '4',
                fault: statusCodePrefix === '5',
                requestId
            });
            if (statusCodePrefix === '4') {
                (0, metric_helper_1.meterFatals)({
                    methodName: 'DetailPage',
                    metricName: `${getDetailPage}:${detailPageRes.name}`,
                    error: true,
                    requestId
                });
            }
            return {
                error
            };
        }
        const tenant = detailPageRes.data.page.tenant.toUpperCase();
        if (tenant) {
            configStoreActions.update({ tenant });
        }
        const countryCodeResp = detailPageRes.data.page.countryCode;
        if (countryCodeResp) {
            const countryCode = countryCodeResp === 'GB' ? 'uk' : countryCodeResp.toLowerCase();
            configStoreActions.update({ countryCode });
        }
        const csrfToken = detailPageRes.data.csrf.csrfToken;
        if (csrfToken) {
            configStoreActions.update({ csrfToken });
        }
        const csrfTokenFault = csrfToken ? false : true;
        (0, metric_helper_1.meterFatals)({
            methodName: 'DetailPage',
            metricName: 'GetCsrfToken',
            tenant,
            success: !csrfTokenFault,
            fault: csrfTokenFault,
            requestId
        });
        (0, metric_helper_1.meterFatals)({
            methodName: 'DetailPage',
            metricName: getDetailPage,
            tenant,
            success: true,
            requestId
        });
        (0, metric_helper_1.emitLatencyMetrics)('DetailPage', getDetailPage, moneraServiceResponseTime, requestId, tenant);
        if (res && envShoppingPortal) {
            const spParams = (0, models_1.getBaseShoppingPortalParams)();
            spParams.pageType = 'MoneraDetailPage';
            spParams.pageSubType = tenant;
            spParams.pageTypeId = asin;
            const shoppingPortalConfig = detailPageRes.data.page.shoppingPortalConfig;
            if (shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navStoreName) {
                spParams.navStoreName = shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navStoreName;
            }
            if (shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navNodeId) {
                spParams.navNodeId = shoppingPortalConfig === null || shoppingPortalConfig === void 0 ? void 0 : shoppingPortalConfig.navNodeId;
            }
            if (spOverrides) {
                Object.keys(spOverrides).forEach((key) => {
                    spParams[key] = spOverrides[key];
                });
            }
            (0, monera_app_core_1.writeShoppingPortalResponseHeaders)(res, spParams);
        }
        const layout = JSON.parse(detailPageRes.data.page.componentDefinitionString);
        configStoreActions.update({ layout });
        return {};
    });
    return DetailPage;
};
exports.createDetailPage = createDetailPage;
